var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#25d366;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "whatsapp-square-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.2,0H97.68a25.27,25.27,0,0,1,25.2,25.2V97.68a25.27,25.27,0,0,1-25.2,25.2H25.2A25.27,25.27,0,0,1,0,97.68V25.2A25.27,25.27,0,0,1,25.2,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.14,36.38A35,35,0,0,0,33.06,78.62l-5,18.14,18.56-4.87a34.93,34.93,0,0,0,16.72,4.27h0A35,35,0,0,0,88.13,36.39ZM63.38,90.25a29.07,29.07,0,0,1-14.82-4.06l-1.06-.63-11,2.88,2.94-10.73-.69-1.11a28.83,28.83,0,0,1-4.46-15.48,29.1,29.1,0,1,1,29.1,29.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.33,68.45c-.87-.44-5.17-2.55-6-2.84s-1.38-.44-2,.44-2.26,2.84-2.77,3.44-1,.66-1.89.22a24.34,24.34,0,0,1-7-4.35,26.71,26.71,0,0,1-4.86-6.06c-.52-.87-.06-1.35.38-1.78s.87-1,1.32-1.53a5.7,5.7,0,0,0,.87-1.46A1.61,1.61,0,0,0,57.32,53c-.22-.44-2-4.75-2.69-6.5S53.19,45,52.65,45,51.56,45,51,45a3.24,3.24,0,0,0-2.33,1.09,9.8,9.8,0,0,0-3.06,7.3c0,4.3,3.13,8.45,3.57,9s6.17,9.42,14.94,13.21c2.09.89,3.71,1.43,5,1.85a12.13,12.13,0,0,0,5.51.34c1.68-.25,5.17-2.11,5.91-4.16A7.26,7.26,0,0,0,81,69.5c-.21-.39-.79-.6-1.67-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.b3422eecc094ef8fb95e29b6b87b158e.svg";
export { ForwardRef as ReactComponent };